import { toast as sonnerToast } from 'sonner';
import { ToastOptions } from './toast.types';
import { VStack } from '../../stack/stack.styled';
import { StyledToast } from './toast.styled';
import { Icons } from 'assets';
import { SVG } from '../../../svg/svg';
import { Button } from '../../button';
import { HStack } from '../../stack';
import { Text } from '../../text';

export interface ToastFn {
  (options: ToastOptions): NonNullable<ToastOptions['id']>;
  dismiss: (id: NonNullable<ToastOptions['id']>) => void;
}

export const toast: ToastFn = (options: ToastOptions) => {
  const { title, description, actions, ...restOptions } = options;

  return sonnerToast.custom(
    (id) => {
      const isActionsToast = !!actions;

      const handleAccept = () => {
        if (isActionsToast) {
          sonnerToast.dismiss(id);
          actions?.onAccept();
        }
      };

      const handleClose = () => {
        sonnerToast.dismiss(id);
        actions?.onCancel?.();
      };

      return (
        <StyledToast>
          <VStack spacing="xs">
            <HStack align="center" justify="space-between">
              <Text variant="body-16">{title}</Text>

              {!isActionsToast && (
                <SVG
                  src={Icons.Cross}
                  props={{ cursor: 'pointer' }}
                  action={handleClose}
                />
              )}
            </HStack>

            <div style={{ maxWidth: '90%' }}>
              <Text>{description}</Text>
            </div>
          </VStack>

          {isActionsToast && (
            <HStack align="center" justify="flex-end" spacing="xs">
              <Button
                mode="accent"
                variant="ghost"
                size="s"
                onClick={handleClose}
              >
                {actions?.cancelLabel ?? 'Отмена'}
              </Button>
              <Button mode="accent" size="s" onClick={handleAccept}>
                {actions?.acceptLabel ?? 'Принять'}
              </Button>
            </HStack>
          )}
        </StyledToast>
      );
    },
    {
      ...restOptions,
      toasterId:
        (restOptions.toasterId ?? actions) ? 'toast-no-swipe' : 'toast-toaster',
      duration: actions ? Infinity : restOptions.duration,
    }
  );
};

toast.dismiss = (id) => {
  sonnerToast.dismiss(id);
};
